import Link from "components/atoms/Link";
import Text from "components/atoms/Text";
import { BASE_URL } from "constants/env";
import { removeItemCouponLocalStoreFlow } from "constants/global";
import { removeProductInProductsLocationDeliveryStoreById } from "constants/location";
import React, { useMemo, useRef } from "react";
import { useDispatch } from "react-redux";
import { removeCartProducts, updateCartProducts } from "redux/actions/products/cart";
import { removeRenewalValue } from "sagas/products/cart";
import { joinClassnames, mapClassnames } from "utils/map-modifier";
import "./index.scss";
import SlideCrossSell from "./SlideCrossSell";

export type StatusOldRenewedInfo = 'add' | 'remove' | 'applied';

interface OldRenewedInfoProps {
  mainProduct?: APICartItem;
  crossSells?: CrossSellProductData[];
  view?: boolean;
  deliveryLine?: boolean;
  useTradeProduct?: boolean;
  isDetail?: boolean;
  addCodePromotion?: boolean;
}

const CrossSell: React.FC<OldRenewedInfoProps> = ({
  mainProduct,
  crossSells,
  view,
  deliveryLine,
  useTradeProduct,
  isDetail,
  addCodePromotion,
}) => {
  const dispatch = useDispatch();
  const refCrossSell = useRef<HTMLDivElement>(null);
  // const firstLoaded = useRef<boolean>(false);
  // const { width } = useWindowSize();
  // const [widthCrossSell, setWidthCrossSell] = useState(0);

  // console.log('refCrossSell.current: ', refCrossSell.current);

  // useEffect(() => {
  //   console.log('crossSells: ', crossSells);
  //   console.log('refCrossSell.current: ', refCrossSell.current?.clientWidth);
  //   if (width && crossSells && crossSells?.length > 0 && refCrossSell.current?.offsetWidth && !firstLoaded.current) {
  //     firstLoaded.current = true;

  //     if (view) {
  //       if (width > 768) {
  //         setWidthCrossSell(refCrossSell.current?.offsetWidth - 32);
  //       } else {
  //         setWidthCrossSell(refCrossSell.current?.offsetWidth - 24);
  //       }
  //     } else {
  //       if (width > 768) {
  //         setWidthCrossSell(refCrossSell.current?.offsetWidth - 150 - 20);
  //       } else {
  //         setWidthCrossSell(refCrossSell.current?.offsetWidth - 100 - 12);
  //       }
  //     }
  //   }
  // }, [width, crossSells, view, refCrossSell.current]);

  const onHandleAdd = (productCrossSell: CrossSellProductData) => {
    dispatch(updateCartProducts({
      product_id: productCrossSell?.crossSellProduct?.id,
      mainCrossSellProductId: productCrossSell.mainProductId
    }, 1));
  };

  const removeProductInLocalStorage = (productId?: number) => {
    const localCart = window.localStorage.getItem("cart");
    if (localCart) {
      const LOCAL_CART = JSON.parse(localCart);

      const UPDATE_LOCAL_CART: LocalCartItem[] = LOCAL_CART
        ? LOCAL_CART.map((localCartItem: LocalCartItem) => ({
          ...localCartItem,
          isHaveSetupService: localCartItem.isHaveSetupService || 0,
        }))
        : [];

      let otherCartItems = UPDATE_LOCAL_CART.filter(
        updateLocalCartItem => updateLocalCartItem.productId !== productId,
      );

      if (otherCartItems.length === 0) {
        window.localStorage.removeItem("cart");
        window.localStorage.removeItem("renewal");
      } else {
        window.localStorage.setItem("cart", JSON.stringify(otherCartItems));
      }
    }
  };

  const onHandleRemove = (productCrossSell: CrossSellProductData) => {
    removeRenewalValue(productCrossSell?.crossSellProduct?.id);
    removeProductInLocalStorage(productCrossSell?.crossSellProduct?.id);
    dispatch(removeCartProducts(null));
    removeProductInProductsLocationDeliveryStoreById(productCrossSell?.crossSellProduct?.id);
    // onRequestToReloadDeliveryLocation && onRequestToReloadDeliveryLocation();
    removeItemCouponLocalStoreFlow();
    sessionStorage.removeItem("_dspCode_");
  };

  const uncheckedCrossSell = useMemo(() => crossSells?.filter((c) => !c.checked), [crossSells]);

  const checkedCrossSell = useMemo(() => view ? crossSells : crossSells?.filter((c) => c.checked), [crossSells, view]);

  if (crossSells && crossSells.length === 0) return null;

  return (
    <div className={`${deliveryLine ? 'm-cart_item-deliveryLine' : ''} `}>
      <div className={mapClassnames("o-crossSell", view ? 'view' : '', isDetail ? 'isDetail' : '')} ref={refCrossSell}>
        <div className="o-crossSell_header">
          <Text className="o-crossSell_title">MÙA KÈM GIẢM THÊM</Text>
        </div>
        <Text className="o-crossSell_howManyChoose">Có {crossSells?.length} lựa chọn mua kèm</Text>
        {
          ((uncheckedCrossSell && uncheckedCrossSell?.length > 0 && !view) || isDetail) && (
            <>
              <div className="o-crossSell_products">

                <div className="o-crossSell_products_crossSells">
                  <SlideCrossSell
                    isDetail={isDetail}
                    view={view}
                    disabled={useTradeProduct}
                    crossSell={isDetail ? crossSells : uncheckedCrossSell}
                    onHandleAdd={onHandleAdd}
                    onHandleRemove={onHandleRemove}
                    addCodePromotion={addCodePromotion}
                  />
                </div>
              </div>
            </>
          )
        }
      </div>

      <ul className="o-crossSell_checked">
        {
          !isDetail && checkedCrossSell?.map((c) => {
            const savedPrice = window.formatMoney((Math.round(Number(c?.crossSellProduct?.price) / 1000) * 1000) - (Number(c?.priceDiscount) / 1000) * 1000);

            return (
              <li key={`cross-sell-${c.id?.toString()}`} className="o-crossSell_checked_item">
                <div className="o-crossSell_products_sub_item">
                  <div className="o-crossSell_products_sub_item-left">
                    <div
                      className={joinClassnames("a-image", 'o-crossSell_products_sub_item_image')}
                    >
                      {!!((isDetail || !view) ? `/san-pham/${c?.crossSellProduct?.productTranslations?.[0]?.slug}` : '') ? (
                        <Link href={(isDetail || !view) ? `/san-pham/${c?.crossSellProduct?.productTranslations?.[0]?.slug}` : ''}>
                          <img
                            className="a-image_img"
                            alt={c?.crossSellProduct?.productTranslations?.[0]?.name || `Cart Image ${c?.crossSellProduct?.id}`}
                            src={`${BASE_URL}${c?.crossSellProduct?.thumbnail
                              ? c?.crossSellProduct?.thumbnail
                              : ''
                              }`}
                            width="100%"
                            height="auto"
                          />
                        </Link>
                      ) : (
                        <img
                          className="a-image_img"
                          alt={c?.crossSellProduct?.productTranslations?.[0]?.name || `Cart Image ${c?.crossSellProduct?.id}`}
                          src={`${BASE_URL}${c?.crossSellProduct?.thumbnail
                            ? c?.crossSellProduct?.thumbnail
                            : ''
                            }`}
                          width="100%"
                          height="auto"
                        />
                      )}
                    </div>

                    <div>
                      <Text className="o-crossSell_products_sub_item_name">{c?.crossSellProduct?.productTranslations?.[0]?.name}</Text>
                      <Text className="o-crossSell_products_sub_item_quantity">
                        Số lượng: 1
                      </Text>
                    </div>
                  </div>

                  <div className="o-crossSell_products_sub_item_price">
                    {
                      !view && (
                        <div
                          role="button"
                          className="o-crossSell_products_sub_item_checkbox"
                          onClick={() => onHandleRemove(c)}
                        >
                          XOÁ
                        </div>
                      )
                    }
                    <span className="o-crossSell_products_sub_item_price-original">
                      {c?.crossSellProduct?.price ? window.formatMoney(Math.round(Number(c?.crossSellProduct?.price) / 1000) * 1000) : ''}
                    </span>
                    <span className="o-crossSell_products_sub_item_price-discount">
                      {c?.crossSellProduct?.price ? window.formatMoney(Math.round(Number(c?.priceDiscount) / 1000) * 1000) : ''}
                    </span>
                    <span className="o-crossSell_products_sub_item_price-detail">
                      {savedPrice ? `Tiết kiệm: ${savedPrice}` : ''}
                    </span>
                  </div>
                </div>
              </li>
            )
          })
        }
      </ul >
    </div >
  );
};

CrossSell.defaultProps = {
};

export default CrossSell;
